<template>
   <div style="font-size:16px">
      <h4 class="text-blue"><b>Nos Collaborateurs</b></h4>
      <p>
         Nos collaborateurs constituent notre première force et un pilier très important de notre entreprise. 
      </p>
      <p>
         Des hommes et des femmes compétents et bien formés sont engagés chaque jour à nos côtés pour faire avancer le groupe et vous satisfaire au mieux.
      </p>
      <p>Un accent particulier est mis sur la formation continue de nos employés afin de vous fournir un service de qualité et vous satisfaire au mieux. </p>
      <h4 class="text-bluen mt-5"><b>Disponibilité du produit</b></h4>
      <p><b>Chez DISTRICOM, c’est zéro rupture.</b> Nous disposons d’une capacité de stockage importante et une flotte automobile conséquente pour assurer l’approvisionnement continu de nos points de vente de gaz et nos différentes stations-services.</p>
      <p>
         Toutes nos stations-services sont ouvertes 24h/24 et 7j/7 pour vous permettre d’accéder à tout moment à vos besoins avec un personnel qualifié, toujours prêt à vous conseiller dans vos choix. 
      </p>
      <h4 class="text-blue mt-5"><b>Ancrage sur le territoire</b></h4>
      <p>Notre implantation sur le territoire national est matérialisée par un important réseau de 14 stations-services et plusieurs points de vente de gaz, qui ne cessent de grossir en nombre. </p>
      <p>Nous sommes présents à Abidjan et dans toutes les grandes villes de l’intérieur du pays.</p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>